import { render } from "./DetailsNew.vue?vue&type=template&id=1cd717ed"
import script from "./DetailsNew.vue?vue&type=script&lang=js"
export * from "./DetailsNew.vue?vue&type=script&lang=js"

import "./DetailsNew.vue?vue&type=style&index=0&id=1cd717ed&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__